<template>

  <v-layout align-center justify-center column fill-height>
    <v-icon color="grey">tune</v-icon>

    <h4>{{ $t('learning') }}</h4>
  </v-layout>

</template>

<script>
  export default {
    name: 'state-learning'
  }
</script>

<style scoped lang="scss">

</style>
